export const appSelector = (state) => state.appManagement;
